var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 394,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 25.5 88 5 59.737 31C192.113-1.01 257.721-1.01 393 17.704",
  stroke: "#FC0",
  strokeWidth: 5
})));
export default SvgLightning;